import script from "./chatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./chatMessage.vue?vue&type=script&setup=true&lang=js"

import "./chatMessage.vue?vue&type=style&index=0&id=7f8ca9fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8ca9fc"]])

export default __exports__